import { Tooltip } from "@mui/material";
import { StyledTraslados } from "../../../../styled/traslados";

const ReportesChartLegend = ({ items = [], symbol = "circle" }) => (
  <StyledTraslados.ChartLegend>
    {items.map((item) => (
      <Tooltip key={item.id} title={item.label} placement="left">
        <StyledTraslados.ChartLegendItem>
          <StyledTraslados.ChartLegendSwatch
            symbol={symbol}
            swatchColor={item.color}
          />
          <StyledTraslados.ChartLegendLabel>
            {item.label}
          </StyledTraslados.ChartLegendLabel>
        </StyledTraslados.ChartLegendItem>
      </Tooltip>
    ))}
  </StyledTraslados.ChartLegend>
);

export default ReportesChartLegend;
